import { MEMORY_GAME_ENABLED } from 'src/config/config'
import { IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype } from 'src/graphql/generated/hooks'
import { FilterOption, TaxonomyType } from 'src/types'

export const basicPlanFeatures = [
  'Compare products',
  'Create a list of followed solutions',
  'Create a list of followed categories',
  // 'Leave ratings and reviews',
]

export const premiumPlanFeatures = [
  // 'Compare products based on 100+ different fields',
  // 'View premium insights',
  // 'View buyers’ guides',
  // 'View testimonials',
  // 'View screenshots and videos',
  'Access to Solution Guides',
  'Access to Premium Knowhow',
  'Access to Vendor Analyses',
  'Access to Legaltech Resources for Lawyers',
  'Access to LTH Navigator',
  'Access to Portfolio Management',
]

export const vendorPlanFeatures = [
  'Create listings',
  'Claim and update existing listings',
  'Upgrade your listings',
  'Communicate with buyers',
]

export const vendorResourceFilters: FilterOption = {
  title: TaxonomyType.ResourceType,
  data: [
    { name: 'Article', id: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype.Article },
    { name: 'Case Study', id: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype.CaseStudy },
    { name: 'Checklist', id: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype.Checklist },
    {
      name: 'Practical Guidance',
      id: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype.PracticalGuidance,
    },
    { name: 'Press Release', id: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype.PressRelease },
    // { name: 'Product Briefing', id: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype.ProductBriefing },
    { name: 'Product Briefing', id: 'Product_Briefing' },
    { name: 'White Paper', id: IEnum_Componentsolutionpropsvendorresourceexternal_Documenttype.WhitePaper },
  ],
}

export const fundingInfosC = [
  { value: 'N_A', label: 'N/A' },
  { value: 'Other', label: 'Other' },
  { value: 'Pre_Seed', label: 'Pre Seed' },
  { value: 'Seed', label: 'Seed' },
  { value: 'Series_A', label: 'Series A' },
  { value: 'Series_B', label: 'Series B' },
  { value: 'Series_C', label: 'Series C' },
  { value: 'Series_D', label: 'Series D' },
]
export const fundingInfo = ['N_A', 'Other', 'Pre_Seed', 'Seed', 'Series_A', 'Series_B', 'Series_C', 'Series_D']

export const fundingAmountsC = [
  { value: 'N_A', label: 'N/A' },
  { value: 'Less_than_One_M', label: '< $1M' },
  { value: 'One_To_Five_M', label: '$1 - 5M' },
  { value: 'Five_To_Ten_M', label: '$5 - 10M' },
  { value: 'Ten_To_TwentyFive_M', label: '$10 - 25M' },
  { value: 'TwentyFive_To_Fifty_M', label: '$25 - 50M' },
  { value: 'Fifty_To_Hundred_M', label: '$50 - 100M' },
  { value: 'More_Than_Hundred_M', label: '> $100M' },
]

export const LTH_SOLUTION_MENU = [
  {
    slg: '/lth-solution/for-law-firms', //, //
    title: 'For Law Firms',
    containerid: 'for-law-firms',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    externalLink: 'https://hub.legaltechnologyhub.com/firms',
    height: '4454px', // '2492px', // '2825px', // '2818px',
  },
  {
    slg: '/lth-solution/for-corporate-legal', //, //
    title: 'For Corporate Legal',
    containerid: 'for-corporate-legal',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    externalLink: 'https://hub.legaltechnologyhub.com/corporate', //'https://hub.legaltechnologyhub.com/corp-legal'
    height: '4568px', // '2492px', // '3244px', // '3335px',
  },
  {
    slg: '/lth-solution/for-vendors', //'', //
    title: 'For Vendors',
    containerid: 'for-vendors',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    externalLink: 'https://hub.legaltechnologyhub.com/vendors',
    height: '4177px', // '2492px', //'3405px', // '3400px',
  },
  {
    slg: '/lth-solution/for-investors', //'', //
    title: 'For Investors',
    containerid: 'for-investors',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    externalLink: 'https://hub.legaltechnologyhub.com/investors-home',
    height: '4378px', // '2492px', //'5373px', // '5136px',
  },
  /* {
    slg: '/lth-solution/for-everyone-else', //'', //
    title: 'For Everyone Else',
    containerid: 'for-everyone-else',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    externalLink: 'https://hub.legaltechnologyhub.com/everyone',
    height: '2492px', //'5335px', // '5097px',
  }, */
]

export const INSIGHTS_MENU = [
  {
    slg: '/blogs/lth-product-briefings/', // 'insights/product-briefing',
    title: 'LTH Product Briefing',
    containerid: 'product-briefing',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    target: '',
  },
  {
    slg: '/blogs/lth-insights-for-law-firms/', // 'insights/law-firms',
    title: 'LTH Insights for Law Firms',
    containerid: 'law-firms',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    target: '',
  },
  {
    slg: '/blogs/lth-insights-for-corporate-legal/', // 'insights/corporate-legal',
    title: 'LTH Insights for Corporate Legal',
    containerid: 'corporate-legal',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    target: '',
  },
  {
    slg: '/blogs/jean-ogrady-for-lth/', // 'insights/jean-o-grady',
    title: 'Jean O’Grady for LTH',
    containerid: 'jean-o-grady',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    target: '',
  } /* 
  {
    slg: '/blogs/clm-simplified-for-lth/', // 'insights/clm-simplified',
    title: 'CLM Simplified for LTH',
    containerid: 'clm-simplified',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    target: '',
  }, */,
  {
    slg: 'https://hub.legaltechnologyhub.com/subscribe',
    title: 'Subscribe to Insights',
    containerid: 'subscribe-to-insights',
    portalId: '21422664',
    formId: 'e6764df8-2bdd-451a-8614-84bfa06f71c9',
    target: '_blank',
  },
  ...(MEMORY_GAME_ENABLED
    ? [
        {
          slg: '/memory-match-2025/play',
          title: `LTH Memory Match 2025`,
          containerid: 'memory-match-2025',
          portalId: '',
          formId: '',
          target: '',
        },
      ]
    : []),
]

export const followTypes = [
  { label: 'Portfolio', value: 'Portfolio', description: 'Solutions your organization currently licenses or uses.' },
  { label: 'Reviewed', value: 'Reviewed', description: "Solutions you've evaluated and decided not to license." },
  {
    label: 'Watching',
    value: 'Watching',
    description: "Solutions you're tracking or considering for future evaluation.",
  },
]

export const followTabTypes = ['All', 'Portfolio', 'Reviewed', 'Watching']

/** Private / Shared portfolio visibility pills (list + follow modals) */
export const PORTFOLIO_VISIBILITY_PILL = {
  privateBg: '#E1EAFB',
  privateText: '#011D58',
  sharedBg: '#D6F4E6',
  sharedText: '#0A6B47',
} as const

export const FOUNDERS_EXECUTIVE_TEAM = 'Founders/ Executive Team'
export const INFO_LEGALTECH_HUB_EMAIL = 'info@legaltechnologyhub.com'
export const FUNDING_DETAILS = 'Funding Details'
export const OPEN_TO_INVESTMENT = 'OPEN TO INVESTMENT'
export const AUDIENCE_CONFIG = {
  localhost: 'o7u8cj1dd42s3tbvbjosorv3,k3j0ncyg9ilu21heoqyvl06l',
  develop: 'mr8fsaxa5ikefsc1dd1h8xws,aji0kj9j2lrdvw10t9e8d6a4',
  uat: 'sjju66jqzuut1srtje8g57ws,ob1e4p13a5wxtwforf4b5a52',
  production: 'ksyiwb4j6g2zn3wyspg9ohht,p7ho70ag85wxsx6scxa3a2qv',
}

export const LINKLATERS_EMAIL_DOMAIN = '@linklaters.com'
export const LINKLATERS_SSO_URL = 'https://www.legaltechnologyhub.com/signin/sso/start?company=linklaters.com'
